module.exports = __webpack_public_path__ + "static/Banner-9-8cc658cd186d02a2ff61c71af5045193.png";